import { render, staticRenderFns } from "./OrderMailDialog.vue?vue&type=template&id=48753e72&scoped=true"
import script from "./OrderMailDialog.vue?vue&type=script&lang=js"
export * from "./OrderMailDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48753e72",
  null
  
)

export default component.exports